import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";

window.bootstrap = {
  Tooltip: {
    VERSION: 5,
  },
};

window.addEventListener("DOMContentLoaded", () => {
  [].slice
    .call(document.querySelectorAll('[data-toggle="tooltip"]'))
    .map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl, {
        template:
          '<div class="tooltip custom-tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
      });
    });
});
